var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.622,
    height: 22.425,
    viewBox: "0 0 19.622 22.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-building",
    "data-name": "Icon awesome-building",
    d: "M19.1,21.023H18.22V1.051A1.051,1.051,0,0,0,17.169,0H2.453A1.051,1.051,0,0,0,1.4,1.051V21.023H.526A.526.526,0,0,0,0,21.549v.876H19.622v-.876A.526.526,0,0,0,19.1,21.023ZM5.606,3.329A.526.526,0,0,1,6.132,2.8H7.884a.526.526,0,0,1,.526.526V5.081a.526.526,0,0,1-.526.526H6.132a.526.526,0,0,1-.526-.526Zm0,4.2a.526.526,0,0,1,.526-.526H7.884a.526.526,0,0,1,.526.526V9.285a.526.526,0,0,1-.526.526H6.132a.526.526,0,0,1-.526-.526Zm2.278,6.482H6.132a.526.526,0,0,1-.526-.526V11.738a.526.526,0,0,1,.526-.526H7.884a.526.526,0,0,1,.526.526V13.49A.526.526,0,0,1,7.884,14.016Zm3.329,7.008h-2.8V17.344a.526.526,0,0,1,.526-.526h1.752a.526.526,0,0,1,.526.526Zm2.8-7.533a.526.526,0,0,1-.526.526H11.738a.526.526,0,0,1-.526-.526V11.738a.526.526,0,0,1,.526-.526H13.49a.526.526,0,0,1,.526.526Zm0-4.2a.526.526,0,0,1-.526.526H11.738a.526.526,0,0,1-.526-.526V7.533a.526.526,0,0,1,.526-.526H13.49a.526.526,0,0,1,.526.526Zm0-4.2a.526.526,0,0,1-.526.526H11.738a.526.526,0,0,1-.526-.526V3.329a.526.526,0,0,1,.526-.526H13.49a.526.526,0,0,1,.526.526Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacility);
export default __webpack_public_path__ + "static/media/icon-facility.885e59661ace0aac75132d6e65e6b958.svg";
export { ForwardRef as ReactComponent };